import React, { HTMLProps } from 'react';
import { filterDOMProps, useForm } from 'uniforms';

export type ErrorsFieldProps = HTMLProps<HTMLDivElement>;

export default function ErrorsField(props: ErrorsFieldProps) {
  const { error, schema } = useForm();
  return !error && !props.children ? null : (
    <div {...filterDOMProps(props)}>
      {props.children}

      <div className="divider"></div>
      <ul>
        {schema.getErrorMessages(error).map((message, index) => (
          <li key={index} className="py-1">
            {message}
          </li>
        ))}
      </ul>
      <div className="divider"></div>
    </div>
  );
}
